import { platformSections } from "./platformDocsData";

export interface OverviewSection {
  id: string;
  title: string;
  group: string;
  content: string;
}

export const overviewGroups: string[] = [
  "Getting Started",
  "Courses & Learning",
  "Certifications & Exams",
  "Learning Paths",
  "AI Study Assistant",
  "Achievements & Gamification",
  "Communication & Support",
  "My Profile & Settings",
];

export const overviewSections: OverviewSection[] = [
  ...platformSections,
];
